import moment from 'moment'
import React, {useEffect, useMemo, useState} from 'react'
import {Dropdown} from 'react-bootstrap'
import ReactPaginate from 'react-paginate'
import {useDispatch, useSelector} from 'react-redux'
import {useDebounce} from '../../../../../../_metronic/helpers'
import {GetPurchaseHistoryStaff} from '../../../GatewayManagement/GatewayManagementSlice/GatewayManagementSlice'
import GlobalRateCardList from '../../../Setup/GlobalRateCard/GlobalRateCardList'
import AddCreditPopup from './modal/AddCreditPopup'
import CreateInvoice from './modal/CreateInvoice'
import PriceRuleForStaffAccount from './modal/PriceRuleForStaffAccount'
import {GetPriceRuleList} from '../../../Setup/GlobalRateCard/GlobalRateCardSlice/GlobalRateCardSlice'
import {AuthenticateUser} from '../../../../../Utils/_helpers/RoleAndPermission'

const Billing = () => {
  const [addCredit, setAddCredit] = useState(false)
  const purchase_history = useSelector((state: any) => state?.paymentGateway?.staffPurchase)
  const ProfileDetatileState = useSelector((state: any) => state?.ProfileData?.ProfileData?.user)

  const credit = useSelector((state: any) => state?.ProfileData?.ProfileData)
  const dispatch = useDispatch()
  const [addCreditPopup, setAddCreditPopup] = useState(false)
  const [invoicePopup, setInvoicePopup] = useState(false)
  const [page, setPage] = useState({
    page: 1,
    size: 10,
    search: '',
    duration: 'month',
  })
  const AddCreditpopup = useMemo(
    () => <AddCreditPopup show={addCreditPopup} handleClose={() => setAddCreditPopup(false)} />,
    [addCreditPopup]
  )
  const CreateinvoicePopup = useMemo(
    () => <CreateInvoice show={invoicePopup} handleClose={() => setInvoicePopup(false)} />,
    [invoicePopup]
  )

  const debouncedSearchTerm = useDebounce(page?.search, 3000)
  useEffect(() => {
    AuthenticateUser('see-credit-history-admin') &&
      dispatch(GetPurchaseHistoryStaff({page, id: ProfileDetatileState?._id}))
  }, [debouncedSearchTerm, page.page, page.size, page.duration])

  useEffect(() => {
    dispatch(GetPriceRuleList({accountId: ProfileDetatileState?.accountId}))
  }, [])
  return (
    <>
      {AddCreditpopup}
      {CreateinvoicePopup}
      <div className='col-md-12'>
        <div className='card mb-6'>
          <div className='card-body'>
            <div className='d-flex flex-wrap flex-sm-nowrap'>
              <div className='flex-grow-1'>
                <div className='d-flex justify-content-between align-items-start flex-wrap mb-2'>
                  <div className='d-flex flex-column'>
                    <div className='d-flex align-items-center mb-2'>
                      <a href='#' className='text-gray-900 text-hover-primary fs-2 fw-bolder me-1'>
                        Credit Balance
                      </a>
                    </div>
                  </div>

                  <div className='d-flex mb-3'>
                    <Dropdown>
                      <Dropdown.Toggle
                        className='btn btn-light-primary btn-sm me-2'
                        id='dropdown-basic'
                      >
                        Add credits
                      </Dropdown.Toggle>

                      <Dropdown.Menu>
                        <Dropdown.Item
                          className='menu-content  p-3 fs-8 text-uppercase'
                          onClick={() => {
                            setInvoicePopup(true)
                          }}
                        >
                          Create invoice
                        </Dropdown.Item>
                        <Dropdown.Item
                          className='menu-content  p-3 fs-8 text-uppercase'
                          onClick={() => {
                            setAddCreditPopup(true)
                          }}
                        >
                          Add credit
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </div>

                <div className='d-flex flex-wrap flex-stack'>
                  <div className='d-flex flex-column flex-grow-1'>
                    <div className='d-flex flex-wrap justify-content-between gap-3'>
                      <div className='border border-gray-300 border-dashed rounded py-3 px-4 mb-3 flex-grow-1'>
                        <div className='d-flex align-items-center'>
                          <div className='fs-2 fw-bolder text-success'>
                            {credit?.credits?.sms} SMS
                          </div>
                        </div>
                        <div className='fw-light text-gray-400'>Last purchased on 12/07/2022</div>
                      </div>
                      <div className='border border-gray-300 border-dashed rounded py-3 px-4 mb-3 flex-grow-1'>
                        <div className='d-flex align-items-center'>
                          <div className='fs-2 fw-bolder text-info'>{credit?.credits?.mms} MMS</div>
                        </div>
                        <div className='fw-light text-gray-400'>Last purchased on 12/07/2022</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='card mb-6'>
          <div className='card-header card-header-stretch border-bottom-0'>
            <div className='card-title d-flex align-items-center'>
              <h3 className='fw-bolder m-0 text-gray-800'>Invoices</h3>
            </div>
            <div className='card-toolbar m-0'>
              <ul className='nav nav-stretch  nav-line-tabs border-transparent'>
                <li className='nav-item'>
                  <a
                    className={`nav-link btn btn-sm btn-color-muted btn-active btn-active-light-primary fw-bolder px-4 me-1 ${
                      page.duration == 'month' && 'active'
                    }`}
                    data-bs-toggle='tab'
                    onClick={() => setPage({...page, duration: 'month'})}
                  >
                    Months
                  </a>
                </li>
                <li className='nav-item'>
                  <a
                    className={`nav-link btn btn-sm btn-color-muted btn-active btn-active-light-primary fw-bolder px-4 me-1 ${
                      page.duration == 'week' && 'active'
                    }`}
                    data-bs-toggle='tab'
                    onClick={() => setPage({...page, duration: 'week'})}
                  >
                    Week
                  </a>
                </li>
                <li className='nav-item'>
                  <a
                    className={`nav-link btn btn-sm btn-color-muted btn-active btn-active-light-primary fw-bolder px-4 me-1 ${
                      page.duration == 'day' && 'active'
                    }`}
                    data-bs-toggle='tab'
                    onClick={() => setPage({...page, duration: 'day'})}
                  >
                    Day
                  </a>
                </li>
                <li className='nav-item'>
                  <a
                    className={`nav-link btn btn-sm btn-color-muted btn-active btn-active-light-primary fw-bolder px-4 me-1 ${
                      page.duration == 'all' && 'active'
                    }`}
                    data-bs-toggle='tab'
                    onClick={() => setPage({...page, duration: 'all'})}
                  >
                    ALL
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className='card-body pt-2'>
            <div className='tab-content'>
              <div className='table-responsive'>
                <table className='table align-middle gs-0 gy-4'>
                  <thead>
                    <tr className='fw-bolder text-muted bg-light text-bolder table-row-gray-200 border-bottom border-top'>
                      <th className='ps-4 min-w-125px rounded-start fw-bolder'>Date</th>
                      <th className='min-w-100px fw-bolder'>Invoice Id</th>
                      <th className='min-w-100px fw-bolder'>Type</th>
                      <th className='min-w-100px fw-bolder'>Total MMS</th>
                      <th className='min-w-100px fw-bolder'>Total SMS</th>
                      <th className='min-w-100px fw-bolder'>Total + GST</th>
                      {/* <th className='min-w-70px fw-bolder'>Status</th> */}
                      <th className='min-w-150px  rounded-end fw-bolder text-end pe-10'>Actions</th>
                    </tr>
                  </thead>
                  <tbody className='p-5'>
                    {purchase_history?.items?.map((data: any, idx: number) => (
                      <tr key={idx}>
                        <td className='ps-3 table-row-gray-200 border-bottom border-top ps-5'>
                          <a
                            //   href='#'
                            className='text-gray-400 d-block mb-1 fs-6'
                          >
                            {moment(data?.purchasedDate).format('MMM DD YYYY')}
                          </a>
                        </td>
                        <td className='table-row-gray-200 border-bottom border-top'>
                          <a
                            //   href='#'
                            className='text-gray-400 d-block mb-1 fs-6'
                          >
                            {data?.invoice}
                          </a>
                        </td>
                        <td className='table-row-gray-200 border-bottom border-top'>
                          <a
                            //   href='#'
                            className={
                              data?.type === 'SMS'
                                ? 'badge badge-light-info'
                                : 'badge badge-light-success'
                            }
                          >
                            {data?.type?.toUpperCase()}
                          </a>
                        </td>
                        <td className='table-row-gray-200 border-bottom border-top'>
                          <a
                            //   href='#'
                            className='text-gray-400 d-block mb-1 fs-6'
                          >
                            {data?.type == 'mms' && data?.allowedMessages}
                          </a>
                        </td>
                        <td className='table-row-gray-200 border-bottom border-top'>
                          <a
                            //   href='#'
                            className='text-gray-400 d-block mb-1 fs-6'
                          >
                            {data?.type == 'sms' && data?.allowedMessages}
                          </a>
                        </td>
                        <td className='table-row-gray-200 border-bottom border-top'>
                          <a
                            //   href='#'
                            className='text-gray-400 d-block mb-1 fs-6'
                          >
                            ${data?.amount}
                          </a>
                        </td>
                        <td className='table-row-gray-200 border-bottom border-top'>
                          <a
                            //   href='#'
                            className={
                              data?.status === 'Paid'
                                ? 'badge badge-light-info'
                                : 'badge badge-light-danger'
                            }
                          >
                            {data?.status}
                          </a>
                        </td>
                        <td className='table-row-gray-200 border-top text-end pe-5'>
                          <button
                            onClick={() => window.open(`${data.invoicePdf}`, '_self')}
                            className='btn btn-sm btn-light btn-active-light-primary me-3 fw-500'
                          >
                            Download
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>

                <div className='abcd '>
                  {/* <select onChange={(e: any) => setPage({...page, size: e.target.value,page:1})}>
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={50}>50</option>
                  <option value={purchase_history?.total}>ALL</option>
                </select> */}
                  <ReactPaginate
                    previousLabel='<'
                    nextLabel='>'
                    pageCount={purchase_history?.totalPages}
                    onPageChange={(e) => setPage({...page, page: e.selected + 1})}
                    containerClassName={'pagiantion'}
                    previousLinkClassName={'pagination__link'}
                    nextLinkClassName={'pagination__link'}
                    disabledClassName={'pagination__link--disabled'}
                    activeClassName={'pagination__link--active'}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <PriceRuleForStaffAccount />
      </div>
    </>
  )
}

export default Billing
